// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'
import VueHead from 'vue-head'
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false
Vue.use(VueHead)

const firebaseConfig = {
  apiKey: 'AIzaSyC7iIPbYtKDedSKz5OtPhHw5180XlQTWkY',
  authDomain: 'zoom-companion.firebaseapp.com',
  databaseURL: 'https://zoom-companion.firebaseio.com',
  projectId: 'zoom-companion',
  storageBucket: 'zoom-companion.appspot.com',
  messagingSenderId: '405615032910',
  appId: '1:405615032910:web:4b3d3e9e66bb4247c8611f'
}

firebase.initializeApp(firebaseConfig)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js